CocoModel = require './CocoModel'
schema = require 'schemas/models/poll.schema'

module.exports = class State extends CocoModel
  @className: 'State'



// WEBPACK FOOTER //
// ./app/models/State.coffee